+function ($) {
    'use strict';

    var ImagePicker = function (element, option) {
        this.element = $(element);

        var self = this;
        this.element.find('input[type="file"]').bind('change', function () {
            $(this).removeAttr('data-tooltip-msg');
            self.loadImage(this);
        });
    };

    ImagePicker.prototype.loadImage = function (input) {
        var file = input.files[0];
        if (!file.type.match('image.*')) {
            input.attr('data-tooltip-msg', 'Файлы могут быть только image типов');
            return;
        }
        var reader = new FileReader();
        var self = this;
        reader.onload = (function (image) {
            return function(e) {
                self.element.find('img').attr('src', e.target.result).css('display', 'inline-block');
                self.element.find('span').css('display', 'none');
            }
        })(file);
        reader.readAsDataURL(file);
    };

    var constructor = function (options) {
        //вернуть надо объект jQuery
        return this.each(function () {
            return new ImagePicker(this, options)
        });
    };



    var old = $.fn.ImagePicker;

    $.fn.ImagePicker = constructor;
    $.fn.ImagePicker.constructor = constructor;

    $.fn.ImagePicker.noConflict = function () {
        $.fn.ImagePicker = old;
        return this;
    }
}(jQuery);